/**
 * Curious Baby bundle picker (snippets/cb-bundle-picker.liquid).
 *
 * Works like the old Rapi widget: the shopper picks a row, and the theme's own
 * Add to cart button (and the sticky cart bar button) adds that row. "This deck
 * alone" is left entirely to Broadcast. A bundle row adds every deck in one
 * /cart/add.js request; the store's automatic discounts price them.
 *
 *   theme:cart:refresh       re-render the drawer (Broadcast + cb-cart-upsell)
 *   theme:cart-drawer:show   opens the drawer, dispatched ON <cart-drawer>
 */
(function () {
  'use strict';
  if (window.__cbBundleReady) return;
  window.__cbBundleReady = true;

  var ATC = '[data-add-to-cart], [data-cart-bar-add-to-cart]';

  function picker() { return document.querySelector('[data-cb-picker]'); }
  function scope(p) { return p.closest('.shopify-section') || document; }
  function form(p) { return scope(p).querySelector('form[data-product-form]'); }
  function priceLabel(p) {
    var f = form(p);
    return f && f.querySelector('[data-add-to-cart] [data-product-price]');
  }
  function selected(p) {
    var input = p.querySelector('.cb-row__input:checked');
    return input && input.value !== 'single' ? input : null;
  }

  function setLabel(p, text) {
    var label = priceLabel(p);
    if (label && label.textContent.trim() !== text) label.textContent = text;
  }

  function sync(p) {
    var bundle = selected(p);
    p.querySelectorAll('.cb-row').forEach(function (row) {
      row.classList.toggle('is-selected', row.querySelector('.cb-row__input').checked);
    });
    scope(p).classList.toggle('cb-bundle-selected', !!bundle);
    var fine = p.querySelector('[data-cb-fine]');
    if (fine) fine.hidden = !bundle;
    if (bundle) {
      setLabel(p, bundle.getAttribute('data-cb-price'));
    } else {
      var single = p.querySelector('[data-cb-single-price]');
      if (single) setLabel(p, single.textContent);
    }
  }

  function watchVariant(p) {
    // Broadcast rewrites the button price when the variant changes. Mirror it
    // into the "this deck alone" row, and put the bundle price back if a bundle
    // is the current choice. Observer callbacks run async, so compare text
    // instead of flagging our own writes, or the two would loop.
    var label = priceLabel(p);
    if (!label || !window.MutationObserver) return;
    new MutationObserver(function () {
      var text = label.textContent.trim();
      var single = p.querySelector('[data-cb-single-price]');
      var bundle = selected(p);
      if (!bundle) {
        if (single && single.textContent.trim() !== text) single.textContent = text;
        return;
      }
      if (text === bundle.getAttribute('data-cb-price')) return;
      if (single) single.textContent = text;
      setLabel(p, bundle.getAttribute('data-cb-price'));
    }).observe(label, { childList: true, characterData: true, subtree: true });
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    } else {
      window.location.href = '/cart';
    }
  }

  function addBundle(p, bundle, button) {
    var error = p.querySelector('[data-cb-error]');
    if (error) error.hidden = true;
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      button.disabled = true;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: JSON.parse(bundle.getAttribute('data-cb-items')) })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'We could not add the set. Please try again.');
          return data;
        });
      })
      .then(openCart)
      .catch(function (err) {
        if (error) {
          error.textContent = err.message;
          error.hidden = false;
        }
      })
      .then(function () {
        if (button) {
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
          button.disabled = false;
        }
      });
  }

  function intercept(event, button) {
    var p = picker();
    if (!p) return;
    var bundle = selected(p);
    if (!bundle) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button && button.getAttribute('aria-busy') === 'true') return;
    addBundle(p, bundle, button);
  }

  // Capture phase on window runs before Broadcast's and the subscription app's
  // own handlers, so a selected bundle never also adds the single deck.
  window.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(ATC);
    if (button) intercept(event, button);
  }, true);
  window.addEventListener('submit', function (event) {
    if (event.target.matches && event.target.matches('form[data-product-form]')) {
      intercept(event, event.target.querySelector('[data-add-to-cart]'));
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('cb-row__input')) return;
    sync(event.target.closest('[data-cb-picker]'));
  });

  function init() {
    var p = picker();
    if (!p || p.__cbInit) return;
    p.__cbInit = true;
    watchVariant(p);
    sync(p);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
